export default dependencies => {
    const {product} = dependencies;
    try {
        const defaultDataModels = require(`@/assets/settings/dataModels/default.json`);
        const productDataModels = require(`@/assets/settings/dataModels/${product}.json`);
        return {dataModels: Object.assign(defaultDataModels, productDataModels)};
    } catch {
        return {dataModels: require(`@/assets/settings/dataModels/default.json`)};
    }
};
